export enum PaymentGatewayEnum {
  STRIPE_PAYMENT_INTENT = 'stripe-payment-intent',
  METAMASK = 'metamask',
  FREE = 'free',
  BRAINTREE = 'braintree',
  PAYPAL = 'paypal',
  MEMBER = 'member',
}
